module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-14.fa653625.png";